'use es6';

export const shouldReinitialize = (oldProps, newProps) => {
  return newProps.config !== oldProps.config || newProps.content !== oldProps.content && newProps.uniqueKey === null || newProps.uniqueKey !== null && newProps.uniqueKey !== oldProps.uniqueKey;
};
export const controlledContentChanged = (oldProps, newProps, editor) => {
  return newProps.content !== oldProps.content && newProps.content !== editor.getContent() && newProps.uniqueKey !== null;
};
export const isUngated = (gates, gateName) => {
  return Array.isArray(gates) && gates.includes(gateName);
};

// handleEditorMouseDown and handleEditorMouseUp are here because of UISelect
// behavior where mousedown events cause the select menu to hide. In those
// instances we don't want mouseup events to fire on the layer behind the
// select menu because it might close the UIPopovers prematurely
const didMouseDownInEditor = {};
const getHandleEditorMouseDown = editor => () => {
  didMouseDownInEditor[editor.id] = true;
};
const getHandleEditorMouseUp = editor => evt => {
  if (!didMouseDownInEditor[editor.id]) {
    evt.preventDefault();
  }
  didMouseDownInEditor[editor.id] = false;
};
export const setupMouseEvents = editor => {
  editor.on('mousedown', getHandleEditorMouseDown(editor));
  editor.on('mouseup', getHandleEditorMouseUp(editor), true);
};